import baseService from './baseService';
import { HOST } from './../utils/config';
import { changePromParam } from "../utils/tool";
import colorApi from './color.js'

// 请求域名
const {ADDRESS, API, RealTime} = HOST;

class BankRuptcyService extends baseService{
  // 获取县列表
  static getCountry(cityId){
    return this.jsonpMethod(`${ADDRESS}/area/get?fid=`+cityId);
  }

  static getNoticeList() {
    return this.jsonpMethod(`${API}?appid=auction-front&functionId=getNoticeList&body={%22publishSource%22:10}`).then(
      res => res.data
    )
  }

  static getResResource(areaId) {
    return this.jsonpMethod(`${API}?appid=auction-front&functionId=queryRequiredDataForBankruptM&body={%22areaId%22:${areaId}}`).then(
      res => res.data && res.data.floorObject
    )
  }

  /**
   * 破产轮播图打标
   * @param areaId
   * @returns {Promise<T>}
   */
  static getResMarking(areaId = '91016') {
    return this.jsonpMethod(`${API}?appid=paimai&functionId=queryDataForAuctionMasking&body={%22areaId%22:${areaId}}`).then(
      res => res.data
    )
  }

  // 破产首页搜索筛选接口
  // param  def  1  无任何筛选条件时，增加运营资源，不传不添加运营位

  static getIndexAuctionList(params) {
    const queryParams = Object.assign(params, {
      merchantsStatus: undefined,
    });
    return colorApi('searchProductListForBankruptM',queryParams)
    // return this.jsonpMethod(`${API}?appid=auction-front&functionId=searchProductListForBankruptM&body=${JSON.stringify(queryParams)}`).then(
    //   res => res.data
    // )
  }

  // 破产搜索列表页搜索筛选接口

  static getSearchAuctionList(params) {
    const queryParams = Object.assign(params, {
      apiType: 0,
      reqSource: 1,
      paimaiTimes: 6,
    })
    return colorApi('paimai_unifiedSearch', queryParams,'paimai-search-soa')
    // return this.jsonpMethod(`${API}?appid=paimai-search-soa&functionId=paimai_unifiedSearch&body=${JSON.stringify(queryParams)}`).then(
    //   res => {
    //     if (res.statusCode != 200) {
    //       return [];
    //     }

    //     return res.datas

    //   }
    // )
  }

  // 搜索列表页筛选接口


  static realTimeRefresh(paimaiIds) {
    return this.jsonpMethod(`${RealTime}/services/currentList.action?paimaiIds=${paimaiIds.join('-')}`)
  }

  // 判断是否显示自营服务费折扣筛选条件
  static justifyShieldConditions() {
    const queryParams = {"page": 1, "pageSize": 40, "selfOrderHasDiscount": 1};
    return this.jsonpMethod(`${API}?appid=auction-front&functionId=searchProductListForBankruptM&body=${JSON.stringify(queryParams)}`).then(
      res => {
        if (res.resultCode === '0004') {
          return false
        } else {
          return true
        }
      }
    )
  }
}

export default BankRuptcyService;

